/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';
import { transition } from '../themes/mainTheme';

export const AccordionWrapper = styled.div<{ $size?: 'small' | 'large' }>`
    font-family: ${props => props.theme.font};
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    background-color: transparent;
    border: ${({ $size, theme }) => $size === 'large' ? `1px solid ${theme.border.decorative}` : 'none'};
`;

export const AccordionHeader = styled.div<{ $isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    cursor: pointer;
    background-color: transparent;
    transition: ${transition('background-color')};
    border: 1px solid transparent;

    &:hover {
        background-color: ${props => props.theme.surface[3]};
    }

    &:focus-visible {
        border: 1px solid ${props => props.theme.border.active};
        border-radius: 2px;
        z-index: 50;
    }

    &:focus:not(:focus-visible) {
        border: 1px solid transparent;
    }
`;

export const Divider = styled.div`
    height: 1px;
    background-color: ${props => props.theme.border.decorative};
    margin: 0 16px;
`;

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Title = styled.h3<{ $size?: 'small' | 'large' }>`
    margin: 0;
    font-weight: 500;
    color: ${props => props.theme.text.primary};
    font-size: ${({ $size }) => ($size === 'large' ? '18px' : '14px')};
`;

export const ChevronWrapper = styled.div<{ $isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: ${transition('transform')};
    transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
    color: ${props => props.theme.text.tertiary};
`;

export const ExtraIconWrapper = styled.div`
    display: flex;
    align-items: center;
    color: ${props => props.theme.text.tertiary};
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const AccordionContentWrapper = styled.div<{ $isOpen: boolean }>`
    display: grid;
    grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
    transition: ${transition('grid-template-rows')};
`;

export const AccordionContent = styled.div`
    overflow: hidden;
`;

export const AccordionInnerContent = styled.div<{ $scrollable?: boolean }>`
    padding: 16px;
    color: ${props => props.theme.text.secondary};
    font-size: 14px;
    ${({ $scrollable }) =>
		$scrollable &&
        `
        max-height: 250px;
        overflow-y: auto;
    `}
`;

